import React, { Component } from 'react';
import { Button, Checkbox, Col, Form, message, Row, Table } from 'antd';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import moment from 'moment';
import { connect } from 'react-redux';
import { BackBtn } from '@comm/BackBtn';
import { queryAnalysisBudgets, queryBudgetStatistics } from '@api/finance/budget';
import util from '@util';
import LocalDb from '@util/localDb';
import getAllType from '@util/getAllType';
import MonthRange from '../../comm/MonthRangePicker';

const FormItem = Form.Item;
const date = new Date();

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: false,
      thead: [],
      expandedRowKeys: [],
      checkedUUids: [],
      show: 'all', // all显示实际和预算
      showChecked: ['actual', 'budget'],
      value: LocalDb.get('date')
        ? [moment(LocalDb.get('date')[0]), moment(LocalDb.get('date')[1])]
        : [moment.unix(date.getTime() / 1000), moment.unix(date.getTime() / 1000)],
      groupUuids: this.props.location.query.groupUuids || [],
    };
  }

  allcheckedUuids = [];

  componentWillMount() {
    this.expandedRowKeys = [];

    this.checkedUUids = [];
  }

  componentDidMount() {
    const table = document.getElementsByClassName('ant-table-scroll')[0];
    table.id = 'table-to-xls';

    const params = {};
    const { value, groupUuids } = this.state;
    params.beginDate = moment(value[0]).format('YYYY-MM');
    params.endDate = moment(value[1]).format('YYYY-MM');
    params.groupUuids = groupUuids;
    getAllType().then(res => {
      this.type = res;
      this.loadData(params);
    });
    this.len = 0;
  }

  loopTitleLen = thead => {
    thead.length > 0 &&
      thead.map(item => {
        if (item.children && item.children.length === 0) {
          this.len++;
          thead.checked = true;
        } else if (item.children && item.children.length > 0) {
          this.loopTitleLen(item.children);
        }
        return item;
      });
    return thead;
  };

  initChecked = thead => {
    thead.length > 0 &&
      thead.map(item => {
        if (item.children && item.children.length === 0) {
          item.checked = true;
          this.checkedUUids.push(item.key);
        } else if (item.children && item.children.length > 0) {
          this.initChecked(item.children);
        }
        return item;
      });
    this.allcheckedUuids = this.checkedUUids.map(item => item);
    this.setState({
      checkedUUids: this.checkedUUids,
    });
    return thead;
  };

  /** 拼接实际和预算 */
  loopJoin = (budget, actual) => {
    budget.map((item, index) => {
      Object.keys(item).forEach(key => {
        if (key !== 'children' && key !== 'type' && key !== 'typeName' && key !== 'apportionFlag') {
          item[key] = `${item[key]}丨${actual[index][key]}`;
        } else if (key === 'children' && item.children && item.children.length > 0) {
          this.expandedRowKeys.push(`${item.uuid}`);
          this.loopJoin(item[key], actual[index][key]);
        }
        item.show = 'all';
      });
      return item;
    });
    return budget;
  };

  joinSum = (budgetSum, actualSum) => {
    const sum = {};
    // eslint-disable-next-line guard-for-in
    Object.keys(budgetSum).forEach(key => {
      sum[key] = `${budgetSum[key]}丨${actualSum[key]}`;
    });
    return sum;
  };

  // 设置收入类目对应的名字
  setIncomeType = income => {
    const { type } = this;
    income.forEach(item => {
      item.direction = 'income';
      type.forEach(typeItem => {
        if (item.type === typeItem.value) {
          item.typeName = typeItem.key;
        }
      });
    });
    return income;
  };

  // 递归给每个单元格设置show属性
  loopSetshow = (data, show) => {
    data.map(item => {
      Object.keys(item).forEach(key => {
        if (key !== 'children' && key !== 'type' && key !== 'typeName' && key !== 'apportionFlag') {
          item.show = show;
        } else if (key === 'children' && item.children && item.children.length > 0) {
          this.loopSetshow(item.children, show);
        }
      });
      return item;
    });
    return data;
  };

  /**
   * 获取预算统计列表
   */
  loadData = searchDate => {
    this.setState({
      isLoading: true,
    });
    this.len = 0;
    const { groupUuids } = this.state;
    groupUuids.length === 0
      ? queryBudgetStatistics(searchDate).then(res => {
          if (res.statusCode === 200) {
            this.loopTitleLen(res.data.thead);
            let data = this.loopJoin(res.data.budget, res.data.actual);
            const sum = this.joinSum(res.data.budgetSum, res.data.actualSum);
            const countSum = this.joinSum(res.data.budgetCountSum, res.data.actualCountSum);
            countSum.typeName = '人力成本+业务成本';
            sum.typeName = '合计';
            res.data.noTypes[0].typeName = '未定义类型';
            data = data.concat(res.data.noTypes);
            data.push(countSum);
            data.push(sum);
            data = this.loopSetshow(data, 'all');
            const thead = this.initChecked(res.data.thead);
            this.setState({
              thead,
              data,
              isLoading: false,
              wid: (this.len + 1) * 250 + 350,
            });
          } else {
            message.error(res.message);
          }
        })
      : queryAnalysisBudgets(searchDate).then(res => {
          if (res.statusCode === 200) {
            this.loopTitleLen(res.data.thead);
            let data = this.loopJoin(res.data.budget, res.data.actual);
            const sum = this.joinSum(res.data.budgetSum, res.data.actualSum);
            const countSum = this.joinSum(res.data.budgetCountSum, res.data.actualCountSum);
            countSum.typeName = '人力成本+业务成本';
            sum.typeName = '合计';
            res.data.noTypes[0].typeName = '未定义类型';
            data = data.concat(res.data.noTypes);
            data.push(countSum);
            data.push(sum);
            data = this.loopSetshow(data, 'all');
            const thead = this.initChecked(res.data.thead);
            this.setState({
              thead,
              data,
              isLoading: false,
              wid: (this.len + 1) * 250 + 350,
            });
          } else {
            message.error(res.message);
          }
        });
  };

  handleSubmit = e => {
    if (e) {
      e.preventDefault();
    }
    const { value, groupUuids } = this.state;
    const params = {};
    params.beginDate = moment(value[0]).format('YYYY-MM-DD');
    params.endDate = moment(value[1]).format('YYYY-MM');
    params.groupUuids = groupUuids;
    LocalDb.set('date', value);
    this.loadData(params);
  };

  handlePanelChange = value => {
    this.setState({
      value,
    });
  };

  transferValue = value => {
    this.setState({
      value,
    });
  };

  searchBar = () => {
    const { value } = this.state;
    const { groupUuids } = this.state;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row type="flex" justify="start">
          {groupUuids.length !== 0 ? (
            <Col>
              <BackBtn />
            </Col>
          ) : null}
          <Col>
            <FormItem style={{ marginBottom: '16px' }}>
              <MonthRange
                startValue={value[0]}
                endValue={value[1]}
                transferValue={transferValue => this.transferValue(transferValue)}
              />
            </FormItem>
          </Col>
          <Col>
            <FormItem style={{ marginBottom: '16px' }}>
              <Button type="primary" htmlType="submit" style={{ marginLeft: '10px' }}>
                搜索
              </Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  };

  /**
   * 跳转至按年统计详情页
   */
  toYearStatic = company => {
    this.props.router.push({
      pathname: `/finance/budgets/${company.key}/year`,
      query: {
        companyName: company.title2,
      },
    });
  };

  toDetail = (uuid, record) => {
    const { value } = this.state;
    const params = {};
    params.beginDate = moment(value[0]).format('YYYY-MM');
    params.endDate = moment(value[1]).format('YYYY-MM');
    params.type = record.type;
    params.fromPage = 'statis';
    if (record.typeName === '未定义类型') {
      params.type = 'NULL';
    }
    params.apportionFlag = record.apportionFlag ? 1 : 0;
    if (params.type) {
      this.props.router.push({
        pathname: `/finance/budget/${uuid}/check`,
        query: params,
      });
    }
  };

  loopchangeCheck = (checkedUUids, thead) => {
    thead.length > 0 &&
      thead.map(item => {
        if (!item.children) {
          const isChecked = checkedUUids.some(uuid => {
            return item.key === uuid;
          });
          item.checked = !!isChecked;
        } else if (item.children && item.children.length > 0) {
          this.loopchangeCheck(checkedUUids, item.children);
        }
        return item;
      });
    return thead;
  };

  handleAllChecked = () => {
    let { checkedUUids, thead } = this.state;
    if (this.allcheckedUuids.length > checkedUUids.length) {
      checkedUUids = [].concat(this.allcheckedUuids);
    } else {
      checkedUUids = [];
    }
    thead = this.loopchangeCheck(checkedUUids, thead);
    thead.pop();
    thead.shift();
    this.setState({
      checkedUUids,
    });
  };

  changeAllCheck = item => () => {
    let { checkedUUids, thead } = this.state;
    const flag = item.children.every(item1 => item1.checked);
    if (flag) {
      item.children.forEach(item1 => {
        checkedUUids = checkedUUids.filter(item2 => item2 !== item1.key);
      });
    } else {
      item.children.forEach(item1 => {
        const notInclude = checkedUUids.every(item2 => item2 !== item1.key);
        if (notInclude) {
          checkedUUids.push(item1.key);
        }
      });
    }
    thead = this.loopchangeCheck(checkedUUids, thead);
    thead.pop();
    thead.shift();
    this.setState({
      checkedUUids,
      thead,
    });
  };

  changeCheck = key => {
    let { thead } = this.state;
    const { checkedUUids } = this.state;
    let index = 0;
    const isChecked = checkedUUids.some(item => {
      return item === key;
    });
    if (isChecked) {
      index = checkedUUids.indexOf(key);
      checkedUUids.splice(index, 1);
    } else {
      checkedUUids.push(key);
    }
    thead = this.loopchangeCheck(checkedUUids, thead);
    thead.pop();
    thead.shift();
    this.setState({
      checkedUUids,
      thead,
    });
  };

  setShow = key => {
    let { data, show, showChecked } = this.state;
    let flag = false;
    showChecked.map(item => {
      if (item === key) {
        flag = true;
      }
      return item;
    });
    if (flag) {
      showChecked = showChecked.filter(item => {
        return item !== key;
      });
    } else {
      showChecked.push(key);
    }
    if (showChecked.length === 2) {
      show = 'all';
    } else if (showChecked.length === 1) {
      show = showChecked[0];
    }
    data = this.loopSetshow(data, show);
    this.setState({
      data,
      show,
      showChecked,
    });
  };

  /**
   * 递归设置表头
   */
  loopTitle = thead => {
    thead.length > 0 &&
      thead.map(item => {
        if (item.dataIndex === 'typeName' || item.dataIndex === 'sum') {
          return null;
        }
        item.title2 = item.title2 || item.title;
        if (!item.children || (item.children && item.children.length === 0)) {
          delete item.children;
          item.title = (
            <p style={{ textAlign: 'center' }}>
              <Checkbox checked={item.checked} onClick={() => this.changeCheck(item.key)} />
              <a onClick={() => this.toYearStatic(item)} style={{ marginLeft: '5px' }}>
                {item.title2}
              </a>
              <p>(实际|预算)</p>
            </p>
          );
          item.dataIndex = item.key;
          item.width = 250;
          item.render = (text, record) => {
            if (record.typeName === '未定义类型') {
              const numFont = util.numberFormat(text, 2, '.', ',');
              return numFont === '0.00' ? (
                <span>-</span>
              ) : (
                <a onClick={() => this.toDetail(item.key, record)}>{numFont}</a>
              );
            }
            if (record.direction === 'income') {
              const numFont = util.numberFormat(text, 2, '.', ',');
              return numFont === '0.00' ? (
                <span>-</span>
              ) : (
                <a onClick={() => this.toDetail(item.key, record)}>{numFont}</a>
              );
            }
            if (record.typeName !== '未定义类型' && !record.direction) {
              const textArr = `${text}`.split('丨');
              const style = {};
              if (parseFloat(textArr[1]) > parseFloat(textArr[0])) {
                style.color = 'red';
              }
              const actualFont = util.numberFormat(textArr[1], 2, '.', ',');
              const budgetFont = util.numberFormat(textArr[0], 2, '.', ',');
              // 只显示实际
              if (record.show === 'actual') {
                if (actualFont === '0.00') {
                  return <span>-</span>;
                }
                if (actualFont !== '0.00') {
                  return <a onClick={() => this.toDetail(item.key, record)}>{actualFont}</a>;
                }
              }
              // 只显示预算
              if (record.show === 'budget') {
                if (budgetFont === '0.00') {
                  return <span>-</span>;
                }
                if (budgetFont !== '0.00') {
                  return <a style={{ color: 'gray' }}>{budgetFont}</a>;
                }
              }
              // 都显示
              if (record.show === 'all') {
                if (actualFont === '0.00' && budgetFont === '0.00') {
                  return <span>-</span>;
                }
                if (actualFont === '0.00') {
                  return <a style={{ color: 'gray' }}>{budgetFont}</a>;
                }
                if (budgetFont === '0.00') {
                  return <a onClick={() => this.toDetail(item.key, record)}>{actualFont}</a>;
                }
                return (
                  <span>
                    <a onClick={() => this.toDetail(item.key, record)} style={style}>
                      {actualFont}
                    </a>
                    <span style={{ margin: '0 5px' }}>丨</span>
                    <a style={{ color: 'gray' }}>{budgetFont}</a>
                  </span>
                );
              }
            }
          };
        } else if (item.children && item.children.length > 0) {
          item.title = (
            <p style={{ textAlign: 'center' }}>
              <Checkbox
                checked={item.children.every(item1 => item1.checked)}
                onClick={() => this.changeAllCheck(item)}
              />
              <span style={{ marginLeft: '5px' }}>{item.title2}</span>
              <p>(实际|预算)</p>
            </p>
          );
          this.loopTitle(item.children);
        }
        return item;
      });
    return thead;
  };

  expandAllRows = () => {
    this.setState({
      expandedRowKeys: this.expandedRowKeys,
    });
  };

  handleExpend = expandedRows => {
    this.setState({
      expandedRowKeys: expandedRows,
    });
  };

  columns = () => {
    const { thead, checkedUUids } = this.state;
    const columns = this.loopTitle(thead);
    if (columns[0] && columns[0].key !== 'typeName') {
      columns.unshift({
        title: (
          <div style={{ textAlign: 'center', height: '109px' }}>
            <a />
            <p />
          </div>
        ),
        dataIndex: 'typeName',
        key: 'typeName',
        width: 250,
        fixed: 'left',
        render: (text, record) => {
          return <span>{record.typeName || record.type}</span>;
        },
      });
    }
    if (columns[0] && columns[columns.length - 1].key !== 'sum') {
      columns.push({
        title: '合计',
        dataIndex: 'sum',
        key: 'sum',
        width: 280,
        fixed: 'right',
        render: (text, record) => {
          if (record.typeName !== '未定义类型' && record.direction !== 'income') {
            let budgetSum = 0;
            let actualSum = 0;
            let item = [];
            let budgetItem = 0;
            let actualItem = 0;
            Object.keys(record).forEach(key => {
              if (checkedUUids.includes(key)) {
                item = `${record[key]}`.split('丨');
                actualItem = parseFloat(item[1]);
                budgetItem = parseFloat(item[0]);
                actualSum += actualItem;
                budgetSum += budgetItem;
                actualSum = parseFloat(actualSum);
                budgetSum = parseFloat(budgetSum);
              }
            });
            const style = {};
            if (parseFloat(actualSum) > parseFloat(budgetSum)) {
              style.color = 'red';
            }
            actualSum = util.numberFormat(actualSum, 2, '.', ',');
            budgetSum = util.numberFormat(budgetSum, 2, '.', ',');

            // 只显示实际
            if (record.show === 'actual') {
              if (actualSum === '0.00') {
                return <span>-</span>;
              }
              if (actualSum === '0.00') {
                return <a>{actualSum}</a>;
              }
            }
            // 只显示预算
            if (record.show === 'budget') {
              if (budgetSum !== '0.00') {
                return <a style={{ color: 'gray' }}>{budgetSum}</a>;
              }
              return <span>-</span>;
            }
            // 都显示
            if (record.show === 'all') {
              if (actualSum === '0.00' && budgetSum === '0.00') {
                return <span>-</span>;
              }
              if (actualSum === '0.00') {
                return <a style={{ color: 'gray' }}>{budgetSum}</a>;
              }
              if (budgetSum === '0.00') {
                return <a>{actualSum}</a>;
              }
              return (
                <span>
                  <a style={style}>{actualSum}</a>
                  <span style={{ margin: '0 5px' }}>丨</span>
                  <a style={{ color: 'gray' }}>{budgetSum}</a>
                </span>
              );
            }
          } else {
            let sum = 0;
            Object.keys(record).forEach(key => {
              const sumFlag =
                key !== 'type' &&
                key !== 'children' &&
                key !== 'parent' &&
                key !== 'uuid' &&
                key !== 'typeName' &&
                key !== 'apportionFlag' &&
                key !== 'direction';
              if (sumFlag) {
                if (checkedUUids.includes(key)) {
                  sum += parseFloat(record[key]);
                  sum = parseFloat(sum);
                }
              }
            });
            const sumFont = util.numberFormat(sum);
            return <span>{sumFont}</span>;
          }
        },
      });
    }

    return columns;
  };

  render() {
    const { data, wid, isLoading, expandedRowKeys, show, checkedUUids } = this.state;
    return (
      <div>
        <Row type="flex">
          <Col style={{ textAlign: 'right' }} span={12}>
            {this.searchBar()}
          </Col>
          <Col span={12} style={{ textAlign: 'right' }}>
            <Checkbox
              onChange={() => this.handleAllChecked()}
              checked={checkedUUids.length === this.allcheckedUuids.length}
            >
              全选
            </Checkbox>
            <Checkbox
              onChange={() => this.setShow('actual')}
              checked={show === 'actual' || show === 'all'}
            >
              实际
            </Checkbox>
            <Checkbox
              onChange={() => this.setShow('budget')}
              checked={show === 'budget' || show === 'all'}
            >
              预算
            </Checkbox>
            <Button onClick={this.expandAllRows} style={{ marginRight: '10px' }}>
              展开全部行
            </Button>
            <ReactHTMLTableToExcel
              id="test-table-xls-button"
              className="download-table-xls-button ant-btn"
              table="table-to-xls"
              filename="tablexls"
              sheet="tablexls"
              style={{
                marginTop: '4px',
              }}
              buttonText="导出"
            />
          </Col>
        </Row>
        <Table
          columns={this.columns()}
          dataSource={data}
          loading={isLoading}
          bordered
          rowKey="uuid"
          size="small"
          expandedRowKeys={expandedRowKeys}
          defaultExpandAllRows
          scroll={{ x: wid, y: util.pageHeight() - 200 }}
          pagination={false}
          onExpandedRowsChange={this.handleExpend}
        />
      </div>
    );
  }
}

export default connect(state => ({
  type: state.income_expend_type,
  account_info: state.account_info,
}))(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/finance/budgets/Index.js